import CompanyPeriods from './CompanyPeriods'
export default CompanyPeriods
